module.exports = __webpack_public_path__ + "static/media/miguel-tepedino.31f53333.png";